import { CartAddEvent } from '@theme/events';

class ProhPairAtc extends HTMLElement {
  connectedCallback() {
    this.addButton = this.querySelector('[data-add-pair]');
    this.statusNode = this.querySelector('[data-status]');
    if (!this.addButton) return;
    this.handleClick = this.handleClick.bind(this);
    this.addButton.addEventListener('click', this.handleClick);
  }

  disconnectedCallback() {
    if (this.addButton && this.handleClick) {
      this.addButton.removeEventListener('click', this.handleClick);
    }
  }

  setStatus(message) {
    if (this.statusNode) this.statusNode.textContent = message;
  }

  getPayload() {
    const firstId = Number(this.dataset.firstVariantId);
    const secondId = Number(this.dataset.secondVariantId);
    const quantity = Number(this.dataset.quantity) || 1;
    const items = [];

    if (Number.isFinite(firstId) && firstId > 0) {
      items.push({ id: firstId, quantity: quantity });
    }
    if (Number.isFinite(secondId) && secondId > 0) {
      items.push({ id: secondId, quantity: quantity });
    }

    const cartItemsComponents = document.querySelectorAll('cart-items-component');
    const sectionsToUpdate = new Set();
    for (const item of cartItemsComponents) {
      if (item instanceof HTMLElement && item.dataset.sectionId) {
        sectionsToUpdate.add(item.dataset.sectionId);
      }
    }

    return {
      items: items,
      sections: Array.from(sectionsToUpdate).join(','),
      sections_url: window.location.pathname,
    };
  }

  async handleClick() {
    const payload = this.getPayload();
    if (!payload.items.length) {
      this.setStatus(this.dataset.errorLabel || 'Unable to add pair. Please try again.');
      return;
    }

    const originalLabel = this.addButton.textContent;
    this.addButton.disabled = true;
    if (this.dataset.addingLabel) this.addButton.textContent = this.dataset.addingLabel;

    try {
      const response = await fetch(Theme.routes.cart_add_url, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Accept: 'application/json',
        },
        body: JSON.stringify(payload)
      });

      if (!response.ok) throw new Error('Request failed');
      const addResponse = await response.json();

      const cartResponse = await fetch('/cart.js');
      if (!cartResponse.ok) throw new Error('Cart fetch failed');
      const cart = await cartResponse.json();

      this.setStatus(this.dataset.addedLabel || 'Pair added to cart.');
      document.dispatchEvent(
        new CartAddEvent(cart, this.id || 'proh-pair-atc', {
          source: 'proh-pair-atc',
          itemCount: (Number(this.dataset.quantity) || 1) * payload.items.length,
          sections: addResponse.sections,
        })
      );
    } catch (error) {
      this.setStatus(this.dataset.errorLabel || 'Unable to add pair. Please try again.');
      console.error('proh-pair-atc error', error);
    } finally {
      this.addButton.disabled = false;
      this.addButton.textContent = originalLabel;
    }
  }
}

if (!customElements.get('proh-pair-atc')) {
  customElements.define('proh-pair-atc', ProhPairAtc);
}
